

import {  useEffect, useState } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import {  toast } from "react-toastify";

import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';

import apiService from "../api/ApiService";
import { useForm } from "react-hook-form";
import { getAdmins, setUsers } from "../redux/slices/adminSlice";
import { isEqual } from "./EditModalDam";
import { Close, MobileFriendly, Person, Title } from "@mui/icons-material";


const EditUserInfo=({data,iindex,flag})=>{
  const [valid,setValid]=useState(false)
    const {currentAdmins,currentUsers}=useSelector(state=>state.p.admin)
    const dispatch=useDispatch()
    const {openModalls2,closeModalls2,isDeleteModalOpen,isOpenModal2,openDeleteModal}=useGlobalContext()
    const mainProp={
      userName:data?.username,
      title:data?.title,
      farmId:data?.farmId,
      phoneNumber:data?.phoneNumber
    }
    const {watch,
        register,
        handleSubmit,
        formState: { errors }
      } = useForm({defaultValues:mainProp});

    const changePass=async(data1)=>{
                const res=await apiService.updateUSerINfo(data.id,data1)
                if(flag==="editAdmin"){
                  console.log("salam")
                  const editedList = [
                    ...currentAdmins.slice(0,iindex),
                    res.data,
                    ...currentAdmins.slice(iindex+1)
                  ];
                  dispatch(getAdmins(editedList))
                  openModalls2()
                }else{
                const editedList = [
                  ...currentUsers[0].slice(0,iindex),
                  res.data,
                  ...currentUsers[0].slice(iindex+1)
                ];
                dispatch(setUsers([editedList,currentUsers[1]]))
                openModalls2()}
    }
    const allData=watch()
    useEffect(()=>{
      setValid(isEqual(mainProp,allData))
    },[allData])
    

    return <div onClick={closeModalls2} className={`modal-overlay ${isOpenModal2&&'show-modal'} `}>
        <form onSubmit={handleSubmit(changePass)} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
            <DriveFileRenameOutlineIcon fontSize="large"/>

            <h4 >به روز رسانی</h4>
            </div>
       
            <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("userName", {
              required: 'این مقدار ضروری است',pattern:{
                value:/^[A-Za-z0-9]+$/,
                message:'فقط حروف لاتین'
              }
            })}/>
            <label for="" className={'labelSS'}><Person fontSize="small"/> نام کاربری  </label>
            {errors?.message?.userName&&<span className='errMsg'> {errors?.message?.userName}  </span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a"  {...register("title", {
              required: 'این مقدار ضروری است'
            })}/>
            <label for="" className={'labelSS'}><Title fontSize="small"/> موضوع </label>
            {errors?.message?.title&&<span className='errMsg'> {errors?.message?.title}  </span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a"  {...register("phoneNumber", {
              required: 'این مقدار ضروری است',pattern:{
                value:/^09\d{9}$/,
                message:'شماره معتبر نیست'
              }
            })}/>
            <label for="" className={'labelSS'}><MobileFriendly fontSize="small"/> شماره همراه </label>
            {errors?.message?.phoneNumber&&<span className='errMsg'> {errors?.message?.phoneNumber}  </span>}
        </div>
        <button disabled={valid} className="EditMOdalBtnForm" type="submit">
            تایید
        </button>
        
        </form>
        <div style={{marginTop:'120px'}}> 
        
        </div>
        
    </div>
}
export default EditUserInfo